export default __webpack_public_path__ + "static/media/hours.inline.37bbfb00.svg";